import { CreditLoader } from "../../components/CustomerDetails/CreditLoader";
import * as urls from "../../urls"; ///utils/urls
import { getCookie } from "../../utils/common";
import axios from "axios";
import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";

// import { connect } from "react-redux";
// import {
//   customerListDetail,
//   customerListDetailSuccess,
// } from "../../store/actions/customerlistdetail"; //../../store/actions/customerlistdetail
import { Grid, Link, TextField, makeStyles } from "@material-ui/core";

import "./creditDetails.css";

import useStyles from "./CustomerDetailsPage.style";
import { FaDotCircle } from "react-icons/fa";
// import { useHistory, useParams } from "react-router";

import { toast } from "react-toastify";

import RefreshIcon from "@mui/icons-material/Refresh";
import Tooltip from "@mui/material/Tooltip";

import leadDetails from "./LeadDetailsPage.module.css";

const CreditScoreArc = (props) => {
  // const history = useHistory();
  const classes = useStyles();
  console.log("props=>", props);
  //   const ContactPermission = JSON.parse(getCookie("customer_permission"));
  function toRadians(angle) {
    return angle * (Math.PI / 180);
  }

  // * Cookies
  const [cookies, setCookie] = useCookies(["user"]);
  console.log(cookies);
  const contact_id = getCookie("contactID");
  const access_token = getCookie("tokenForCustomers");
  console.log(access_token, "tokenForCustomers");
  const [creditScore, setCreditScore] = useState("300");
  const { score, setScore } = props;
  // const [score, setScore] = useState("");
  console.log("score", creditScore);
  const [crifStatus, setCrifStatus] = useState(null);
  console.log("crifStatus", crifStatus);
  // const [isLoading, setIsLoader] = useState(false);
  // const newCreditStyle = newStyleCred();
  // const boxStyle = useStylesNew();
  // const newStyle = newUseStyle();
  // const [isLoading, setIsLoading] = useState(false);
  const [paymentPercentage, setPaymentPercentage] = useState(0);
  const [cardUtilizationPer, setCardUtilizationPer] = useState(0);
  // const [paymentHistoryArr, setPaymentHistoryArr] = useState([]);
  const [totalAge, setTotalAge] = useState("");
  const [totalOverdueAmt, setTotalOverdueAmt] = useState(false);
  // const [lastConvertedDate, setLastConvertedDate] = useState();
  // const [openDetails, setOpenDetails] = useState({});
  const [arrListNew, setArrList] = useState([]);
  const [duplicateList, setDuplicateList] = useState([]);
  // const classStyle = useStNew();
  // const layoutContext = useContext(LayoutContext);
  // const history = useHistory();

  // const domain = getCookie("domain");
  // const location = useLocation();

  const [selectedFilter, setSelectedFilter] = useState("");

  const headersCommonNew = {
    domain_name: "yoindi",
    Authorization: `Bearer ${access_token || ""}`,
    "Content-Type": "application/json",
  };

  const [loanDetails, setLoanDetails] = useState({
    total: 0,
    personalLoan: 0,
    homeLoan: 0,
    creditLoans: 0,
    autoLoans: 0,
    otherLoans: 0,
    totalBalance: "",
    personalLoanBalance: "",
    homeLoanBalance: "",
    creditLoanBalance: "",
    autoLoanBalance: "",
    otherLoanBalance: "",
    totalDisbursedCount: "",
    totalPersonalLoanDisbursedCount: "",
    totalHomeLoanDisbursedCount: "",
    totalCreditLoanDisbursedCount: "",
    totalAutoLoanDisbursedCount: "",
    totalOtherLoanDisbursedCount: "",
    totalAmountPercentage: "",
    personalLoanAmountPer: "",
    homeLoanAmountPer: "",
    creditLoanAmountPer: "",
    autoLoanAmountPer: "",
    otherLoanAmountPer: "",
  });

  function numDifferentiation(value) {
    const val = Math.abs(value);
    return `${(value / 100000).toFixed(2)}`;
  }
  console.log("props?.contact=>", props?.ContactId);
  useEffect(() => {
    let nba2 = { contact_id: props?.ContactId };
    // props.customerListDetail(nba2);
  }, [props?.ContactId]);

  const pullBureauData = () => {
    setIsLoader(true);

    let bodyData = {
      contact_id: props?.ContactId,
    };
    var config7 = {
      method: "post",
      url: `${process.env.REACT_APP_API_BASE_URL}${urls.CREDIT_DETAILS}`,
      headers: headersCommonNew,
      data: bodyData,
    };

    axios(config7)
      .then(function (response) {
        // props?.getDetails(true);
        console.log("Inside Then :", response?.data);
        const crifstatuss = response?.data?.msg;
        console.log("crifStatus", crifstatuss);
        setCrifStatus(crifstatuss);

        // setIsLoader(false);
        if (response?.data?.["B2C-REPORT"]?.SCORES[0]?.SCORE?.["SCORE-VALUE"]) {
          setCreditScore(
            response?.data?.["B2C-REPORT"]?.SCORES[0]?.SCORE?.["SCORE-VALUE"]
          );

          setScore(
            response?.data?.["B2C-REPORT"]?.SCORES[0]?.SCORE?.["SCORE-VALUE"]
          );
          let personalLoanCount = [];
          let creditLoanCount = [];
          let homeLoanCount = [];
          let autoLoanCount = [];
          let otherLoanCount = [];
          let totalBalance = 0;
          let totalDisbursedCount = 0;
          let personalLoanBalanceCount = 0;
          let personalLoanDisbursedCount = 0;
          let creditLoanBalanceCount = 0;
          let creditLoanDisbursedCount = 0;
          let homeLoanBalanceCount = 0;
          let homeLoanDisbursedCount = 0;
          let autoLoanBalanceCount = 0;
          let autoLoanDisbursedCount = 0;
          let otherLoanBalanceCount = 0;
          let otherLoanDisbursedCount = 0;

          response?.data?.["B2C-REPORT"]?.RESPONSES?.map((item) => {
            // console.log("Start If");

            if (
              item?.RESPONSE?.["LOAN-DETAILS"]?.["ACCOUNT-STATUS"] === "Active"
            ) {
              // console.log("Inside If");
              totalBalance =
                parseInt(
                  item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                    /,/g,
                    ""
                  )
                ) + totalBalance;
              totalDisbursedCount =
                parseInt(
                  item?.RESPONSE?.["LOAN-DETAILS"]?.["DISBURSED-AMT"].replace(
                    /,/g,
                    ""
                  )
                ) + totalDisbursedCount;
              // console.log("Upper Personal Loan");
              if (
                item?.RESPONSE?.["LOAN-DETAILS"]?.["ACCT-TYPE"] ===
                "Personal Loan"
              ) {
                // console.log("Inside Personal Loan");
                personalLoanCount.push(0);
                personalLoanBalanceCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"]?.replace(
                      /,/g,
                      ""
                    )
                  ) + personalLoanBalanceCount;
                personalLoanDisbursedCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.[
                      "DISBURSED-AMT"
                    ]?.replace(/,/g, "")
                  ) + personalLoanDisbursedCount;
              } else if (
                item?.RESPONSE?.["LOAN-DETAILS"]?.["ACCT-TYPE"] ===
                "Credit Card"
              ) {
                creditLoanCount.push(0);
                creditLoanBalanceCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                      /,/g,
                      ""
                    )
                  ) + creditLoanBalanceCount;
                creditLoanDisbursedCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["DISBURSED-AMT"].replace(
                      /,/g,
                      ""
                    )
                  ) + creditLoanDisbursedCount;
              } else if (
                item?.RESPONSE?.["LOAN-DETAILS"]?.["ACCT-TYPE"] === "Home Loan"
              ) {
                homeLoanCount.push(0);
                homeLoanBalanceCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                      /,/g,
                      ""
                    )
                  ) + homeLoanBalanceCount;
                homeLoanDisbursedCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["DISBURSED-AMT"].replace(
                      /,/g,
                      ""
                    )
                  ) + homeLoanDisbursedCount;
              } else if (
                item?.RESPONSE?.["LOAN-DETAILS"]?.["ACCT-TYPE"]?.includes(
                  "Wheeler"
                )
              ) {
                autoLoanCount.push(0);
                autoLoanBalanceCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                      /,/g,
                      ""
                    )
                  ) + autoLoanBalanceCount;
                autoLoanDisbursedCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["DISBURSED-AMT"].replace(
                      /,/g,
                      ""
                    )
                  ) + autoLoanDisbursedCount;
              } else {
                otherLoanCount.push(0);
                otherLoanBalanceCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                      /,/g,
                      ""
                    )
                  ) + otherLoanBalanceCount;
                otherLoanDisbursedCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                      /,/g,
                      ""
                    )
                  ) + otherLoanDisbursedCount;
              }
            }
            console.log("Line no 243");
          });
          console.log("this is before totalBalancePer");
          let totalBalancePer = 0;
          if (totalBalance > 0 && totalDisbursedCount > 0) {
            totalBalancePer = (
              (totalBalance / totalDisbursedCount) *
              100
            ).toFixed(2);
          }

          let personalLoanPer = 0;
          if (personalLoanBalanceCount > 0 && personalLoanDisbursedCount > 0) {
            personalLoanPer = (
              (personalLoanBalanceCount / personalLoanDisbursedCount) *
              100
            ).toFixed(2);
          }
          let creditLoanPer = 0;
          if (creditLoanBalanceCount > 0 && creditLoanDisbursedCount > 0) {
            creditLoanPer = (
              (creditLoanBalanceCount / creditLoanDisbursedCount) *
              100
            ).toFixed(2);
          }

          let homeLoanPer = 0;
          if (homeLoanBalanceCount > 0 && homeLoanBalanceCount > 0) {
            homeLoanPer = (
              (homeLoanBalanceCount / homeLoanDisbursedCount) *
              100
            ).toFixed(2);
          }
          let autoLoanPer = 0;
          if (autoLoanBalanceCount > 0 && autoLoanDisbursedCount > 0) {
            autoLoanPer = (
              (autoLoanBalanceCount / autoLoanDisbursedCount) *
              100
            ).toFixed(2);
          }

          let otherLoanPer = 0;
          if (otherLoanBalanceCount > 0 && otherLoanDisbursedCount > 0) {
            otherLoanPer = (
              (otherLoanBalanceCount / otherLoanDisbursedCount) *
              100
            ).toFixed(2);
          }
          console.log("this is before setLoanDetails");

          setLoanDetails({
            ...loanDetails,
            personalLoan: personalLoanCount?.length,
            creditLoans: creditLoanCount?.length,
            otherLoans: otherLoanCount?.length,
            homeLoan: homeLoanCount?.length,
            autoLoans: autoLoanCount?.length,
            totalAmountPercentage: totalBalancePer,
            personalLoanAmountPer: personalLoanPer,
            homeLoanAmountPer: homeLoanPer,
            creditLoanAmountPer: creditLoanPer,
            autoLoanAmountPer: autoLoanPer,
            otherLoanAmountPer: otherLoanPer,
            totalDisbursedCount: numDifferentiation(totalDisbursedCount),
            totalPersonalLoanDisbursedCount: numDifferentiation(
              personalLoanDisbursedCount
            ),
            totalCreditLoanDisbursedCount: numDifferentiation(
              creditLoanDisbursedCount
            ),
            totalOtherLoanDisbursedCount: numDifferentiation(
              otherLoanDisbursedCount
            ),
            totalHomeLoanDisbursedCount: numDifferentiation(
              homeLoanDisbursedCount
            ),
            totalAutoLoanDisbursedCount: numDifferentiation(
              autoLoanDisbursedCount
            ),
            totalBalance: numDifferentiation(totalBalance),
            personalLoanBalance: numDifferentiation(personalLoanBalanceCount),
            creditLoanBalance: numDifferentiation(creditLoanBalanceCount),
            otherLoanBalance: numDifferentiation(otherLoanBalanceCount),
            homeLoanBalance: numDifferentiation(homeLoanBalanceCount),
            autoLoanBalance: numDifferentiation(autoLoanBalanceCount),
            total:
              personalLoanCount?.length +
              creditLoanCount?.length +
              otherLoanCount?.length +
              homeLoanCount?.length +
              autoLoanCount?.length,
            //  response?.data?.data?.["B2C-REPORT"]?.RESPONSES?.length
          });
        } else {
          toast.warning(response?.data?.msg);
        }
        console.log("Inside Then End");
      })
      .catch(function (err) {
        console.log("err.response : ", err.response);
        // alert(err.response.data.message);
      });
  };

  useEffect(() => {
    console.log("inside useEffect", props?.ContactId);
    // setIsLoader(true);

    let bodyData = {
      contact_id: props?.ContactId,
    };
    console.log("Body", bodyData);
    var config7 = {
      method: "post",
      url: `${process.env.REACT_APP_API_BASE_URL}${urls.CREDIT_DETAILS_DB}`,
      headers: headersCommonNew,
      data: bodyData,
    };

    axios(config7)
      .then(function (response) {
        console.log("Response=>", response?.data?.data);
        // setIsLoader(false);
        if (
          response?.data?.data?.["B2C-REPORT"]?.SCORES[0]?.SCORE?.[
            "SCORE-VALUE"
          ]
        ) {
          console.log(
            "Score=>",
            response?.data?.data?.["B2C-REPORT"]?.SCORES[0]?.SCORE?.[
              "SCORE-VALUE"
            ]
          );
          setCreditScore(
            response?.data?.data?.["B2C-REPORT"]?.SCORES[0]?.SCORE?.[
              "SCORE-VALUE"
            ]
          );

          setScore(
            response?.data?.data?.["B2C-REPORT"]?.SCORES[0]?.SCORE?.[
              "SCORE-VALUE"
            ]
          );
          let personalLoanCount = [];
          let creditLoanCount = [];
          let homeLoanCount = [];
          let autoLoanCount = [];
          let otherLoanCount = [];
          let totalBalance = 0;
          let totalDisbursedCount = 0;
          let personalLoanBalanceCount = 0;
          let personalLoanDisbursedCount = 0;
          let creditLoanBalanceCount = 0;
          let creditLoanDisbursedCount = 0;
          let homeLoanBalanceCount = 0;
          let homeLoanDisbursedCount = 0;
          let autoLoanBalanceCount = 0;
          let autoLoanDisbursedCount = 0;
          let otherLoanBalanceCount = 0;
          let otherLoanDisbursedCount = 0;
          response?.data?.data?.["B2C-REPORT"]?.RESPONSES?.map((item) => {
            if (
              item?.RESPONSE?.["LOAN-DETAILS"]?.["ACCOUNT-STATUS"] === "Active"
            ) {
              totalBalance =
                parseInt(
                  item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                    /,/g,
                    ""
                  )
                ) + totalBalance;
              totalDisbursedCount =
                parseInt(
                  item?.RESPONSE?.["LOAN-DETAILS"]?.["DISBURSED-AMT"].replace(
                    /,/g,
                    ""
                  )
                ) + totalDisbursedCount;
              if (
                item?.RESPONSE?.["LOAN-DETAILS"]?.["ACCT-TYPE"] ===
                "Personal Loan"
              ) {
                personalLoanCount.push(0);
                personalLoanBalanceCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                      /,/g,
                      ""
                    )
                  ) + personalLoanBalanceCount;
                personalLoanDisbursedCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["DISBURSED-AMT"].replace(
                      /,/g,
                      ""
                    )
                  ) + personalLoanDisbursedCount;
              } else if (
                item?.RESPONSE?.["LOAN-DETAILS"]?.["ACCT-TYPE"] ===
                "Credit Card"
              ) {
                creditLoanCount.push(0);
                creditLoanBalanceCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                      /,/g,
                      ""
                    )
                  ) + creditLoanBalanceCount;
                creditLoanDisbursedCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["DISBURSED-AMT"].replace(
                      /,/g,
                      ""
                    )
                  ) + creditLoanDisbursedCount;
              } else if (
                item?.RESPONSE?.["LOAN-DETAILS"]?.["ACCT-TYPE"] === "Home Loan"
              ) {
                homeLoanCount.push(0);
                homeLoanBalanceCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                      /,/g,
                      ""
                    )
                  ) + homeLoanBalanceCount;
                homeLoanDisbursedCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["DISBURSED-AMT"].replace(
                      /,/g,
                      ""
                    )
                  ) + homeLoanDisbursedCount;
              } else if (
                item?.RESPONSE?.["LOAN-DETAILS"]?.["ACCT-TYPE"].includes(
                  "Wheeler"
                )
              ) {
                autoLoanCount.push(0);
                autoLoanBalanceCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                      /,/g,
                      ""
                    )
                  ) + autoLoanBalanceCount;
                autoLoanDisbursedCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["DISBURSED-AMT"].replace(
                      /,/g,
                      ""
                    )
                  ) + autoLoanDisbursedCount;
              } else {
                otherLoanCount.push(0);
                otherLoanBalanceCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                      /,/g,
                      ""
                    )
                  ) + otherLoanBalanceCount;
                otherLoanDisbursedCount =
                  parseInt(
                    item?.RESPONSE?.["LOAN-DETAILS"]?.["CURRENT-BAL"].replace(
                      /,/g,
                      ""
                    )
                  ) + otherLoanDisbursedCount;
              }
            }
          });

          let totalBalancePer = 0;
          if (totalBalance > 0 && totalDisbursedCount > 0) {
            totalBalancePer = (
              (totalBalance / totalDisbursedCount) *
              100
            ).toFixed(2);
          }

          let personalLoanPer = 0;
          if (personalLoanBalanceCount > 0 && personalLoanDisbursedCount > 0) {
            personalLoanPer = (
              (personalLoanBalanceCount / personalLoanDisbursedCount) *
              100
            ).toFixed(2);
          }
          let creditLoanPer = 0;
          if (creditLoanBalanceCount > 0 && creditLoanDisbursedCount > 0) {
            creditLoanPer = (
              (creditLoanBalanceCount / creditLoanDisbursedCount) *
              100
            ).toFixed(2);
          }

          let homeLoanPer = 0;
          if (homeLoanBalanceCount > 0 && homeLoanBalanceCount > 0) {
            homeLoanPer = (
              (homeLoanBalanceCount / homeLoanDisbursedCount) *
              100
            ).toFixed(2);
          }
          let autoLoanPer = 0;
          if (autoLoanBalanceCount > 0 && autoLoanDisbursedCount > 0) {
            autoLoanPer = (
              (autoLoanBalanceCount / autoLoanDisbursedCount) *
              100
            ).toFixed(2);
          }

          let otherLoanPer = 0;
          if (otherLoanBalanceCount > 0 && otherLoanDisbursedCount > 0) {
            otherLoanPer = (
              (otherLoanBalanceCount / otherLoanDisbursedCount) *
              100
            ).toFixed(2);
          }

          setLoanDetails({
            ...loanDetails,
            personalLoan: personalLoanCount?.length,
            creditLoans: creditLoanCount?.length,
            otherLoans: otherLoanCount?.length,
            homeLoan: homeLoanCount?.length,
            autoLoans: autoLoanCount?.length,
            totalAmountPercentage: totalBalancePer,
            personalLoanAmountPer: personalLoanPer,
            homeLoanAmountPer: homeLoanPer,
            creditLoanAmountPer: creditLoanPer,
            autoLoanAmountPer: autoLoanPer,
            otherLoanAmountPer: otherLoanPer,
            totalDisbursedCount: numDifferentiation(totalDisbursedCount),
            totalPersonalLoanDisbursedCount: numDifferentiation(
              personalLoanDisbursedCount
            ),
            totalCreditLoanDisbursedCount: numDifferentiation(
              creditLoanDisbursedCount
            ),
            totalOtherLoanDisbursedCount: numDifferentiation(
              otherLoanDisbursedCount
            ),
            totalHomeLoanDisbursedCount: numDifferentiation(
              homeLoanDisbursedCount
            ),
            totalAutoLoanDisbursedCount: numDifferentiation(
              autoLoanDisbursedCount
            ),
            totalBalance: numDifferentiation(totalBalance),
            personalLoanBalance: numDifferentiation(personalLoanBalanceCount),
            creditLoanBalance: numDifferentiation(creditLoanBalanceCount),
            otherLoanBalance: numDifferentiation(otherLoanBalanceCount),
            homeLoanBalance: numDifferentiation(homeLoanBalanceCount),
            autoLoanBalance: numDifferentiation(autoLoanBalanceCount),
            total:
              personalLoanCount?.length +
              creditLoanCount?.length +
              otherLoanCount?.length +
              homeLoanCount?.length +
              autoLoanCount?.length,
          });
        }
      })
      .catch(function (err) {
        // setIsLoader(false);
      });
  }, [props?.ContactId]);

  const valueToDegree = () => {
    let value = parseInt(creditScore);
    let newValue = value - 300;
    if (newValue === 0 || newValue < 0) return 90;

    let getDegree = (parseInt(creditScore) - 300) / 3.3;
    return getDegree + 90;
  };

  const newStyle = makeStyles((theme) => ({
    animatedItem: {
      animation: `$myEffect 3000ms ${theme.transitions.easing.easeInOut}`,
      transform: `rotate(${valueToDegree()}deg)`,
    },

    "@keyframes myEffect": {
      from: {
        transform: "rotate(90deg)",
      },
      to: {
        transform: `rotate(${valueToDegree()}deg)`,
      },
    },
  }));

  const animationStyle = newStyle();
  let contactId = props?.ContactId;
  console.log(contactId, ":contactId");
  const Arc = (props) => {
    let percentage =
      //props.user.score
      (600 - 300) / 550;
    let angle;
    if (percentage > 0.65) {
      angle = 90 - percentage * 90;
    } else {
      angle = 45 - percentage * 45;
    }
    let d = toRadians(angle);
    let x, y;
    let cos = 100 * Math.cos(d);
    let sin = 100 * Math.sin(d);
    if (percentage > 0.65) {
      x = Math.abs(Math.max(cos, sin));
      y = Math.abs(Math.min(cos, sin));
    } else {
      x = Math.abs(Math.min(cos, sin));
      y = Math.abs(Math.max(cos, sin));
    }
    return (
      <div
        id="arc"
        className="arc"
        style={{
          zIndex: 1,
          right: "66px",
          marginTop: "-30px",
          bottom: "-9px",
          transform: "scale(0.69)",
        }}
      >
        {/* {isLoading && (
          <p className="fetch" style={{ position: "relative", top: "0px", left: "78px",width:"20px" }}>
            <CreditLoader />
          </p>
        )} */}
        <div
          className={
            creditScore < 600
              ? `${classes.scoreLine} ${classes.bad_selected}`
              : `${classes.scoreLine} ${classes.bad}`
          }
        ></div>
        <div
          className={
            creditScore >= 600 && creditScore < 750
              ? `${classes.scoreLine} ${classes.fair_selected}`
              : `${classes.scoreLine} ${classes.fair}`
          }
        ></div>
        <div
          className={
            creditScore >= 750 && creditScore < 800
              ? `${classes.scoreLine} ${classes.good_selected}`
              : `${classes.scoreLine} ${classes.good}`
          }
        ></div>
        <div
          className={
            creditScore >= 800
              ? `${classes.scoreLine} ${classes.excellent_selected}`
              : `${classes.scoreLine} ${classes.excellent}`
          }
        ></div>

        <div
          className="accent"
          id="low"
          style={{ position: "relative", top: "98px", left: "-7px" }}
        >
          300
        </div>

        <div
          className="accent"
          id="high"
          style={{ position: "relative", top: "76px", left: "182px" }}
        >
          900
        </div>

        <div
          id="currentScoreContainer"
          style={{
            bottom: "-190px",
          }}
        >
          <div className="">
            {score && (
              <div
                className={`${leadDetails.needle} ${animationStyle.animatedItem}`}
              ></div>
            )}
            <span
              className="origin"
              style={{ position: "relative", top: "26px", left: "87px" }}
            >
              <FaDotCircle
                style={{
                  fontSize: "24px",
                  color: "#333333",
                }}
              />
            </span>
          </div>
          <div id="flex column" style={{ marginTop: "50%" }}>
            <span
              id="currentScore"
              style={{
                position: "relative",
                top: "-0px",
                left: "68px",
                fontSize: "36px",
              }}
            >
              <b>{score ? creditScore : "000"}</b>
            </span>
          </div>
          <div style={{ position: "relative", top: "-6px", left: "78px" }}>
            <span id="currentScoreDetail">
              {score &&
                (creditScore < 600
                  ? "Poor"
                  : creditScore >= 600 && creditScore < 750
                  ? "Fair"
                  : creditScore >= 750 && creditScore < 800
                  ? "Good"
                  : creditScore >= 800
                  ? "Excellent"
                  : "No")}
            </span>
          </div>
        </div>
        {console.log("inside credit score comp762=>", contactId)}
        {/* <Link
          onClick={() =>
            history.push({
              pathname: `/crif`,
              state: {
                id: contactId,

                name: props?.full_name,
                leadDetails: true,
                appId: props?.appId,
                leadsPagePath: props?.leadsPagePath,
              },
            })
          }
          to="/crif"
          style={{
            position: "relative",
            top: "-35px",
            left: "3.8rem",
            fontSize: "1.2rem",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          Details
        </Link> */}

        <Tooltip title="Pull Bureau Score">
          <RefreshIcon
            onClick={() => {
              pullBureauData();
            }}
            variant="contained"
            disableElevation
            style={{
              position: "relative",
              top: "-62px",
              left: "134px",
              color: "#0a2472",
              cursor: "pointer",
            }}
          />
        </Tooltip>
        <p
          style={{
            fontSize: 20,
            position: "relative",
            top: -20,
            left: "79px",
            zIndex: "1000",
          }}
        >
          {crifStatus === "Data not found from bureau" ? "No Buro" : ""}
        </p>
        {/* {isLoading && (
          <p
            className="fetch"
            style={{
              position: "relative",
              top: "-7px",
              left: "74px",
              zIndex: "1000",
              width: "30px",
            }}
          >
            <CreditLoader />
          </p>
        )} */}
      </div>
    );
  };

  // console.log("customerDetailListData=>", customerDetailListData);
  // props.getDataFromCreditScoreCardArc(customerDetailListData);

  return (
    <div>
      <div>
        {/* {isLoading && ( */}

        {/* )} */}
      </div>
      {console.log("inside credit score comp820=>", props?.ContactId)}
      <Arc
        contactId={props?.ContactId}
        // full_name={props?.full_name}
        // appId={props?.appId}
        // leadsPagePath={props?.leadsPagePath}
      />
    </div>
  );
};

export default CreditScoreArc;
